import axios from 'axios';
import Cookies from 'js-cookie';
import configData from '../config.json';

const getAuthHeaders = () => {
  const token = Cookies.get('_udxdworkid');
  return token ? { Authorization: `Token ${token}` } : {};
};

// Legacy - kept for backwards compatibility
export const getCategories = () => {
  return axios.get(`${configData.API_URL}/api/support-categories/`);
};

// New dynamic form type APIs
export const getFormTypes = () => {
  return axios.get(`${configData.API_URL}/api/form-types/`, {
    headers: getAuthHeaders()
  });
};

export const getFormDefinition = (slug) => {
  return axios.get(`${configData.API_URL}/api/form-types/${slug}/`, {
    headers: getAuthHeaders()
  });
};

export const getTickets = () => {
  return axios.get(`${configData.API_URL}/api/support-tickets/`, {
    headers: getAuthHeaders()
  });
};

export const createTicket = (data) => {
  // If data has form_type and field_values, use JSON format (new dynamic form)
  if (data.form_type && data.field_values) {
    return axios.post(`${configData.API_URL}/api/support-tickets/`, data, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
  }

  // Legacy: FormData format for backwards compatibility
  const formData = new FormData();

  Object.keys(data).forEach(key => {
    if (key === 'attachments') {
      data.attachments.forEach(file => formData.append('attachments', file));
    } else if (data[key] !== null && data[key] !== undefined) {
      formData.append(key, data[key]);
    }
  });

  return axios.post(`${configData.API_URL}/api/support-tickets/`, formData, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const getTicketDetail = (id) => {
  return axios.get(`${configData.API_URL}/api/support-tickets/${id}/`, {
    headers: getAuthHeaders()
  });
};

export const addAttachment = (ticketId, file, fieldName = null) => {
  const formData = new FormData();
  formData.append('files', file);
  if (fieldName) {
    formData.append('field_name', fieldName);
  }

  return axios.post(`${configData.API_URL}/api/support-tickets/${ticketId}/attachments/`, formData, {
    headers: {
      ...getAuthHeaders(),
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const addResponse = (ticketId, message, files = []) => {
  const formData = new FormData();
  formData.append('message', message);

  files.forEach(file => {
    formData.append('files', file);
  });

  return axios.post(`${configData.API_URL}/api/support-tickets/${ticketId}/responses/`,
    formData,
    {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    }
  );
};

// Get user's products for product dropdown
export const getUserProducts = () => {
  return axios.get(`${configData.API_URL}/api/user-products/`, {
    headers: getAuthHeaders()
  });
};

// Get other users in the current user's client org, for the CC selector
export const getOrgUsers = () => {
  return axios.get(`${configData.API_URL}/api/org-users/`, {
    headers: getAuthHeaders()
  });
};

// Staff-only endpoints
export const getClientsForFilter = () => {
  return axios.get(`${configData.API_URL}/api/support-clients/`, {
    headers: getAuthHeaders()
  });
};

export const getProductsForFilter = () => {
  return axios.get(`${configData.API_URL}/api/support-products/`, {
    headers: getAuthHeaders()
  });
};

export const getAllTickets = (filters = {}, page = 1) => {
  const params = new URLSearchParams();
  if (filters.client) params.append('client', filters.client);
  if (filters.status) params.append('status', filters.status);
  if (filters.product) params.append('product', filters.product);
  if (page > 1) params.append('page', page);

  const queryString = params.toString();
  const url = `${configData.API_URL}/api/support-tickets/${queryString ? '?' + queryString : ''}`;

  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

export const updateTicketStatus = (ticketId, status) => {
  return axios.patch(`${configData.API_URL}/api/support-tickets/${ticketId}/status/`,
    { status },
    {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    }
  );
};
